import { useDrawingStore } from '@/store/drawing'
import type { DrawingStore } from '@/store/drawing'

interface DrawingItem {
  id?: string | number;
  type?: string;
  draggable?: boolean;
  file?: string;
  height?: number;
  is_can_user_approve?: boolean;
  is_can_user_select?: boolean;
  is_item_campaign_pm_user?: boolean;
  is_released?: boolean;
  opacity?: number;
  scaleX?: number;
  scaleY?: number;
  sign?: number;
  sign_additional_functional_areas?: number[];
  sign_additional_functional_areas_names?: string[];
  sign_glossary_text_1_arr?: string[];
  sign_glossary_text_2_arr?: string[];
  sign_glossary_pic_name_arr?: string[];
  sign_qty?: number;
  sign_short_code?: string;
  sign_short_name?: string;
  sign_status?: number | null;
  sign_type?: number | null;
  sign_type_colour?: string;
  tagX?: number;
  tagY?: number;
  width?: number;
  x?: number;
  y?: number;
}

// Fas - functional areas
const compareFunctionalAreaFilters = (
  signFas: number[] | null | undefined,
  selectedFas: any[]
): boolean => {
  if (selectedFas.length === 0) {
    return true  // If selectedFas is empty, return true
  }

  if (!signFas) {
    return false  // If signFas is undefined, return false
  }

  // Check if at least one element of selectedFas is in signFas
  return selectedFas.some(fa => signFas.includes(fa))
}

export const handleWayfindingSignFilters = (
  item: DrawingItem | undefined,
  selectedSignStatuses: any[],
  selectedSignTypes: any[],
  selectedFunctionalAreas: any[],
  signSearchFilter: string,
  signSearchByFilter: 'sign_code' | 'sign_glossary' | 'sign_glossary_pictogram' | 'fa',
  selectedSignIdsFilter: number[]
): boolean => {
  const drawingStore: DrawingStore = useDrawingStore() // Access the store

  // Hide all sign items except the selected one
  if (drawingStore?.specificItemIdToShow) {
    return drawingStore.specificItemIdToShow === item?.id
  }

  if (!item || !item.type) {
    return false // broken drawing item
  }

  const signStatusFilters = selectedSignStatuses.length === 0 ||
    (item.sign_status !== undefined && selectedSignStatuses.includes(item.sign_status))

  const signTypeFilters = selectedSignTypes.length === 0 ||
    (item.sign_type !== undefined && selectedSignTypes.includes(item.sign_type))

  const functionalAreaFilters = compareFunctionalAreaFilters(
    item.sign_additional_functional_areas,
    selectedFunctionalAreas
  )

  const searchTerm: string = signSearchFilter.toLowerCase()
  const additionalAreas: string[] = item?.sign_additional_functional_areas_names || []
  const glossaryItems: string[] = [
    ...(item?.sign_glossary_text_1_arr || []),
    ...(item?.sign_glossary_text_2_arr || [])
  ]
  const pictogramNames: string[] = item?.sign_glossary_pic_name_arr || []
  const signSearchFilters: boolean = signSearchFilter === '' ||
    (
      signSearchByFilter === 'sign_code' &&
      (item?.sign_short_name || '').toLowerCase().includes(searchTerm)
    ) ||
    (
      signSearchByFilter === 'fa' &&
      additionalAreas.some(area => area.toLowerCase().includes(searchTerm))
    ) ||
    (
      signSearchByFilter === 'sign_glossary' &&
      glossaryItems.some(item => item.toLowerCase().includes(searchTerm))
    ) ||
    (
      signSearchByFilter === 'sign_glossary_pictogram' &&
      pictogramNames.some(pic => pic.toLowerCase().includes(searchTerm))
    )

  let signIdFilters: boolean = selectedSignIdsFilter.length === 0
    ? true
    : selectedSignIdsFilter.includes(item?.sign || 0)


  return (item.type === 'sign' && signStatusFilters && signTypeFilters && functionalAreaFilters && signSearchFilters
    && signIdFilters)
}
